import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { CheckCircle2, XCircle } from "lucide-react";

export default function ImportHealth() {
  const { t } = useLang();
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/import-health").then((r) => setData(r.data)); }, []);
  if (!data) return <div>{t("loading")}</div>;
  return (
    <div>
      <div className="eyebrow">Admin</div>
      <h1 className="text-2xl font-bold" style={{ color: "var(--brand-navy)" }}>Import Health</h1>
      <p className="text-sm text-[#4A627A] mt-1">Live counts vs spec targets. All checks must be green after a fresh import.</p>
      <div className="mt-4 overflow-x-auto hag-surface">
        <table className="w-full text-sm">
          <thead className="bg-[#FAF6F0] text-[#4A627A] uppercase text-xs tracking-widest">
            <tr>
              <th className="p-3 text-left">Metric</th>
              <th className="p-3 text-left">Expected</th>
              <th className="p-3 text-left">Actual</th>
              <th className="p-3 text-left">Status</th>
            </tr>
          </thead>
          <tbody>
            {data.checks.map((c) => (
              <tr key={c.metric} data-testid={`ih-${c.metric}`} className="border-t border-[#1B3A5C]/5">
                <td className="p-3">{c.metric}</td>
                <td className="p-3 font-semibold">{String(c.expected)}</td>
                <td className="p-3">{String(c.actual)}</td>
                <td className="p-3">
                  {c.ok ? (
                    <span className="status-chip pace-green flex items-center gap-1 w-fit"><CheckCircle2 size={12}/> OK</span>
                  ) : (
                    <span className="status-chip pace-red flex items-center gap-1 w-fit"><XCircle size={12}/> FAIL</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="mt-4 hag-surface p-4">
        <div className="eyebrow">Raw actuals</div>
        <div className="mt-2 grid grid-cols-2 md:grid-cols-4 gap-3 text-sm">
          {Object.entries(data.actual).filter(([k, v]) => typeof v !== "object").map(([k, v]) => (
            <div key={k}>
              <div className="text-[10px] uppercase tracking-widest text-[#7C8E9E]">{k}</div>
              <div className="text-lg font-bold" style={{ color: "var(--brand-navy)" }}>{v}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
